import { Dayjs } from 'dayjs';
import {
  DateTimeFormat,
  DateTimeFormateLeftToRight,
  ISRAEL_TIMEZONE,
  UTC,
} from '../../config/constants';
import moment from 'moment';
import momentZ from 'moment-timezone';

export function changeTimeZone(
  string_time: string,
  oldTimeZone: string,
  newTimeZone: string,
) {
  if (oldTimeZone === UTC) {
    return moment
      .utc(string_time, 'YYYY-MM-DD HH:mm:ss')
      .tz(newTimeZone)
      .format('YYYY-MM-DD HH:mm:ss');
  }
  return moment
    .tz(string_time, 'YYYY-MM-DD HH:mm:ss', oldTimeZone)
    .utc()
    .format('YYYY-MM-DD HH:mm:ss');
}

export function changeShiftTimeZone(
  shift: any, // TODO fix any
  oldTimeZone: string,
  newTimeZone: string,
) {
  return {
    ...shift,
    start_datetime: changeTimeZone(
      shift.start_datetime,
      oldTimeZone,
      newTimeZone,
    ),
    end_datetime: changeTimeZone(shift.end_datetime, oldTimeZone, newTimeZone),
  };
}

export function formateServerDateToLocaleDate(
  date: Date | string | undefined,
  desiredFormat: string = DateTimeFormateLeftToRight,
  desiredTimeZone: string = ISRAEL_TIMEZONE,
) {
  if (
    !date ||
    (typeof date === 'string' && Number.isNaN(Date.parse(date))) ||
    date === '0000-00-00 00:00:00'
  ) {
    return 'No Date';
  }
  return momentZ
    .utc(date, DateTimeFormat)
    .tz(desiredTimeZone)
    .format(desiredFormat);
}

export const ceilToNearestTenMinutes = (time: Dayjs) => {
  const minutes = time.minute();
  const ceilMinutes = Math.ceil(minutes / 10) * 10;
  return time.minute(ceilMinutes).second(0); // Ceil and reset seconds to 0
};
